import React from 'react';
import PropTypes from 'prop-types';

import { Nav } from 'react-bootstrap5';

import CategoryIconWithTitle from './CategoryIconWithTitle';

export default function CategoryTabItem({ item, count }) {
  return (
    <Nav.Item>
      <Nav.Link className="icon-with-text" eventKey={`category-${item.id}`}>
        <CategoryIconWithTitle item={item} count={count} />
      </Nav.Link>
    </Nav.Item>
  );
}

CategoryTabItem.propTypes = {
  item: PropTypes.object.isRequired,
  count: PropTypes.number,
};

CategoryTabItem.defaultProps = {
  count: null,
};
